<template>
    <facet-template
        :show-clear-link="isFiltered"
        v-bind="$attrs"
        @clear="clear"
    >
        <div slot="facetLabel">
            <div class="d-flex align-items-center flex-wrap">
                <div class="mr-2">{{ title }}</div>
                <small
                    v-if="value.length > 0"
                    class="font-italic font-weight-normal"
                >
                    ({{ value.length }})
                </small>
            </div>
        </div>
        <b-container class="searchfacet-checkbox-group">
            <b-row>
                <b-col cols="12" class="p-0">
                    <b-form-group class="m-0">
                        <b-form-checkbox-group
                            v-model="selected"
                            plain
                            stacked
                            style="outline: 0"
                            @input="change"
                        >
                            <b-form-checkbox
                                v-for="option in options"
                                :key="option.value"
                                :value="option.value"
                                class="mb-2"
                            >
                                {{ option.text }}
                            </b-form-checkbox>
                        </b-form-checkbox-group>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-container>
    </facet-template>
</template>

<style lang="scss">
$light-gray: #eaeaea;
$primary-blue: #007dc6;
$check-mark-active: #54b848;
$dark-gray: #444;

.searchfacet-checkbox-group {
    .form-check {
        padding: 16px 0 16px 16px;

        &:not(:last-child) {
            border-bottom: 1px solid $light-gray;
        }

        &:first-child {
            padding-top: 8px;
        }

        &:last-child {
            padding-bottom: 0;
        }

        color: $dark-gray;

        .form-check-label {
            min-width: 100%;
            cursor: pointer;
            user-select: none;
        }

        input[type="checkbox"] {
            visibility: hidden;

            & + label {
                font-weight: normal;
            }
        }

        input[type="checkbox"]:checked + label {
            color: $primary-blue;
            user-select: none;
            position: relative;

            &:after {
                color: $check-mark-active;
                content: "check";
                font-family: "Material Icons";
                font-weight: normal;
                font-style: normal;
                font-size: 1rem;
                line-height: 1;
                letter-spacing: normal;
                text-transform: none;
                display: inline-block;
                white-space: nowrap;
                word-wrap: normal;
                direction: ltr;
                top: 0;
                position: absolute;
                padding-left: 6px;
                -webkit-font-feature-settings: "liga";
                -webkit-font-smoothing: antialiased;
            }
        }
    }
}
</style>

<script>
import _ from "lodash";
import FacetTemplate from "./FacetTemplate";

export default {
    components: {
        FacetTemplate,
    },

    props: {
        options: {
            type: Array,
            required: true,
        },
        value: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            selected: [],
        };
    },

    watch: {
        selected(newVal) {
            this.$emit("input", newVal);
        },
        value(newVal) {
            this.selected = newVal;
        },
    },

    computed: {
        isFiltered() {
            return !_.isEmpty(this.value);
        },
    },

    created() {
        this.selected = this.value;
    },

    methods: {
        change(checked) {
            this.$emit("input", checked);
        },
        clear() {
            if (_.size(this.selected) > 0) {
                this.selected = [];
            }
        },
    },
};
</script>
